import useApi from 'api';
import React from 'react';

import Store from 'store';
import EditingContext from 'store/editingContext';
import { ErrorPopup } from 'ui/utils/Overlay';
import { OverlayContext } from 'ui/utils/OverlayManager';
import Dialog from 'ui/dialog';
import { stateFix } from 'logic/stateReducers';

const OverwriteDialog = ({ onResolve, onClose }) => (
  <Dialog title={`Load profile`} modal onClose={onClose}>
    <Dialog.Content>
      <p>{`Discard current profile?`}</p>
    </Dialog.Content>
    <Dialog.Footer>
      <button onClick={() => onResolve(true)}>{`Ok`}</button>
      <button onClick={onClose}>{`Cancel`}</button>
    </Dialog.Footer>
  </Dialog>
);

export default function useLoadProfile(builder) {
  const overlays = React.useContext(OverlayContext);
  const setSpinner = EditingContext.useStateSetter("spinner");
  const api = useApi();

  const mainStore = Store.useStore();
  const dispatch = Store.useDispatch();

  return React.useCallback(id => {
    setSpinner(spin => spin + 1);
    api.load(id).then(
      async result => {
        if (builder ? !result.builder : (!result.embeds || !result.embeds.length)) {
          overlays.async(<ErrorPopup message={`Empty profile!`}/>);
          return;
        }
        const state = mainStore.getState();

        let action = 'overwrite';
        if ((builder ? state.builder : state.embeds.length) && !state.imported) {
          action = await overlays.async(<OverwriteDialog/>);
          if (!action) return;
        }
        dispatch.setState(stateFix(result, id, result.user));
      },
      error => {
        overlays.async(<ErrorPopup reason={error.message}/>);
      },
    ).finally(() => setSpinner(spin => spin - 1));
  }, [api, overlays, setSpinner, mainStore, dispatch, builder]);
}

export function exportProfile(state, name) {
  state = {...state};
  delete state.id;
  state.embeds = state.embeds.map(embed => ({...embed}));
  delete state.imported;
  delete state.importedId;
  delete state.user;
  if (name != null) {
    state.name = name;
  }

  state.class = state.builder?.class || state.embeds[state.activeEmbed]?.class;
  state.category = state.builder?.category;

  return state;
}
